import React, { useState } from "react";
import { Form, Row, Col, Button, Alert } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo_dark from "../assets/img/logo.png";
import { ShowToast } from "../common/function";
import { verifyOtp } from "../common/api";
// import { verifyOtp } from "../common/api"; // if needed

export default function OtpScreen() {

  const { state } = useLocation();
  const email = state?.email;
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateOtp = () => {
    if (!otp) return "OTP is required";
    if (!/^\d{6}$/.test(otp)) return "Enter a valid 6-digit OTP";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateOtp();
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setLoading(true);

    // Optional: verify OTP via API
    const res = await verifyOtp({ otp, email });
    console.log(res);
    setTimeout(() => {
      setLoading(false);
      if (res.success === true) {
        ShowToast(1, "OTP verified");
        navigate("/reset-password", { state: { email: email } }); // or your next screen
      } else {
        ShowToast(0, res.message || "OTP verification failed");
      }
    }, 1000);
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={6} className="loginform">
          <div className="loginmain_div maxwidth500 mx-auto">
            <div className="headlogin_div mb-4">
              <img className="loginlogo_img" src={logo_dark} alt="" />
              <h2>
                Enter <span>OTP</span>
              </h2>
              <p>
                We've sent a 6-digit OTP to your email. Please enter it below to
                continue.
              </p>
            </div>

            <Form onSubmit={handleSubmit}>
              {error && (
                <Alert variant="danger" className="mb-3">
                  {error}
                </Alert>
              )}

              <Form.Group className="mb-4 form-group">
                <Form.Label>Enter OTP</Form.Label>
                <Form.Control
                  type="text"
                  maxLength="6"
                  placeholder="Enter 6-digit OTP"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value)) setOtp(value);
                    if (error) setError("");
                  }}
                  isInvalid={!!error}
                />
              </Form.Group>

              <Button
                type="submit"
                className="btn btn-primary w-100 mt-3"
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </Button>

              <p className="formfooter text-center mt-3">
                Back To <Link to="/">Login</Link>
              </p>
            </Form>
          </div>
        </Col>

        <Col lg={6} className="loginmb_none">
          <div className="loginlogo_div">
            <Link to="/">
              <img src={logo_dark} alt="" />
            </Link>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}
